<div class="rehau-logo"> <img src="assets/images/rehau-logo.svg-data.svg" height="50px" />
    <span class="logout" *ngIf="isLoggedIn" (click)="logout()">Logout</span>
</div>
<div class="headline-wrapper">
  <div class="headline">
    <h1>RE.GUARD 2.0 Service</h1>
    <h2>Get helpful information about RE.GUARD 2.0 devices. </h2>
  </div>
</div>
